
import React from 'react'

import { IconButton, Link, List, Box } from '@mui/material'
import {
  footerBarSx,
  footerLegalLinkSx,
  footerLegalLinkSpacedSx,
  footerSocialIconSx,
  footerSocialListSx,
} from '@/layout-blueprints/chromeComponentSx'

import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import TwitterIcon from '@mui/icons-material/Twitter'
import YouTubeIcon from '@mui/icons-material/YouTube'

import { connect } from 'react-redux'
import useAffiliate from '@/hooks/useAffiliate'
import { Link as RouterLink } from 'react-router'

const Footer = (props) => {
  const {
    footerShadow,
    footerBgTransparent,
    footerFixed,
    sidebarToggle,
  } = props
  const [{ affiliate, affiliateLoading, urlDomain, urlAffiliate }] =
    useAffiliate({})

  return (
    <>
      <Box
        sx={{
          ...footerBarSx({
            shadow: footerShadow,
            opacityBg: footerBgTransparent,
            fixed: footerFixed,
            collapsed: sidebarToggle,
          }),
          color: 'rgba(7, 9, 25, 0.5)',
        }}
      >
        <Box>
          <List component="div" sx={[{ display: 'flex', alignItems: 'center' }, {
            "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
              color: "#368cff",
              background: "rgba(54, 140, 255, 0.05)",
              "&::before": { background: "#368cff" },
            },
          }]}>
            <Link
              component={RouterLink}
              to="/Terms"
              target="_blank"
              sx={footerLegalLinkSx}
            >
              <span>Terms</span>
            </Link>
            <Link
              component={RouterLink}
              to="/Privacy"
              target="_blank"
              sx={footerLegalLinkSpacedSx}
            >
              <span>Privacy</span>
            </Link>
            <Link
              component={RouterLink}
              to="/Legal"
              target="_blank"
              sx={footerLegalLinkSx}
            >
              <span>Legal Disclaimer</span>
            </Link>
          </List>
        </Box>
        <Box data-hf="footer-second">
          <span>
            Copyright © {new Date().getFullYear()}{' '}
            {(affiliate?.companyName === 'Deal Sauce (Subto)'
              ? 'Deal Sauce'
              : affiliate?.companyName) || 'Housefolios'}
            , inc.
          </span>
        </Box>
        {!urlAffiliate && (
          <List component="div" sx={[{ whiteSpace: 'nowrap', display: 'flex', justifyContent: 'center' }, footerSocialListSx, {
            "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": {
              "&.Mui-selected, &:hover": {
                background: "transparent",
                color: "#368cff",
                "&::before": { background: "transparent" },
              },
              "&.text-white-50.Mui-selected, &.text-white-50:hover": { color: "#fff !important" },
              "&.text-black-50.Mui-selected, &.text-black-50:hover": { color: "#000 !important" },
              "& .MuiTouchRipple-root": { opacity: 0 },
            },
          }]}>
            <IconButton
              target="_blank"
              href="https://www.linkedin.com/company/housefolios/"
              size="large"
              sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
            >
              <LinkedInIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
            </IconButton>
            <IconButton
              target="_blank"
              href="https://www.facebook.com/Housefolios/"
              size="large"
              sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
            >
              <FacebookIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
            </IconButton>
            <IconButton
              target="_blank"
              href="https://www.instagram.com/housefolios/"
              size="large"
              sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
            >
              <InstagramIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
            </IconButton>
            <IconButton
              target="_blank"
              href="https://www.youtube.com/channel/UCrtQVie1gdD6-8puYRM0Auw"
              size="large"
              sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
            >
              <YouTubeIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
            </IconButton>
            <IconButton
              target="_blank"
              href="https://twitter.com/housefolios"
              size="large"
              sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
            >
              <TwitterIcon sx={[{ fontSize: "1.15rem !important" }, footerSocialIconSx]} />
            </IconButton>
          </List>
        )}
      </Box>
    </>
  )
}
const mapStateToProps = (state) => ({
  footerShadow: state.DeprecatedThemeOptions.footerShadow,
  footerBgTransparent:
    state.DeprecatedThemeOptions.footerBgTransparent,
  footerFixed: state.DeprecatedThemeOptions.footerFixed,
  sidebarToggle: state.DeprecatedThemeOptions.sidebarToggle,
})

export default connect(mapStateToProps)(Footer)
